export interface HistoricalStockPricesInput {
  ticker: string
  startDate: string
  endDate: string
}

export interface StockPrice {
  date: string
  openPrice: number
  highPrice: number
  lowPrice: number
  closePrice: number
  volume: number
}

export interface HistoricalStockPrices {
  __typename: 'HistoricalStockPrices'
  ticker: string
  name: string
  exchange: string
  prices: StockPrice[]
}

/* eslint-disable no-unused-vars */
export enum HistoricalStockPricesErrorType {
  TICKER_NOT_FOUND = 'TICKER_NOT_FOUND',
  NO_PRICE_DATA_AVAILABLE = 'NO_PRICE_DATA_AVAILABLE',
  FAILED_TO_FETCH_PRICE_DATA = 'FAILED_TO_FETCH_PRICE_DATA',
}

export interface HistoricalStockPricesError {
  __typename: 'HistoricalStockPricesError'
  errorType: HistoricalStockPricesErrorType
}

export type HistoricalStockPricesOutput = HistoricalStockPrices | HistoricalStockPricesError
